import clubAction from '../actions/club';
import CRUDReducer from './CRUDReducer';

const clubCRUDReducer = new CRUDReducer(clubAction);

export default (state, action) => clubCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/club.js